class SubscriptionPicker extends HTMLElement {
  constructor() {
    super();

    const _this = this;
    this.cart =
      document.querySelector("cart-notification") ||
      document.querySelector("cart-drawer");
    this.sellingPlanContainer = this.querySelector(".selling-plan-fieldset");
    this.tieredPricingContainer = this.querySelector(
      ".tiered-pricing-fieldset"
    );
    this.purchaseOptions = this.querySelectorAll(
      'input[name="purchaseOption"]'
    );
    this.sellingPlanInput = document.querySelectorAll(
      'input[name="selling_plan"]'
    );

    this.cartBubble = document.querySelector("#cart-icon-bubble");
    this.productScope = this.closest('product-info') || this.parentElement;
    this.form = this.productScope.querySelector('product-form form[action*="/cart/add"]');
    this.submitFormButton = this.form?.querySelector('[type="submit"]');

    if (this.form) {
      this.form.addEventListener("submit", this.onFormSubmitHandler.bind(this));
    }

    this.classList.add("loading");

    this.purchaseOptions.forEach(function (radio) {
      if (radio.value == "subscription" && radio.checked) {
        _this.init();
      }
    });

    this.purchaseOptions.forEach(function (radio) {
      radio.addEventListener("change", function (event) {
        const purchaseOptionsElements =
          radio?.parentElement?.parentElement?.querySelectorAll(".radio");
        purchaseOptionsElements?.forEach((item) => {
          item?.classList?.remove("radio--active");
        });

        radio?.parentElement?.classList?.add("radio--active");
        if (event.target.value == "onetime") {
          // one time select
          _this.productScope
            .querySelectorAll('input[name="selling_plan"]')
            .forEach(function (input) {
              input.value = ""; // clear the selling plan id
            });
          _this.sellingPlanContainer.classList.add("hidden");
          _this.tieredPricingContainer?.classList.remove("hidden");
          _this.initTieredPricing();
        } else {
          _this.sellingPlanContainer.classList.remove("hidden");
          _this.tieredPricingContainer?.classList.add("hidden");
          _this.updateProductFormQuantity(1);
          _this.init();
        }
      });
    });
  }

  onFormSubmitHandler(evt) {
    if (!this.submitFormButton) return;
    this.submitFormButton.setAttribute("aria-disabled", true);
    this.submitFormButton.classList.add("loading");
    this.submitFormButton
      .querySelector(".loading__spinner")
      .classList.remove("hidden");
  }

  initTieredPricing() {
    if (!this.tieredPricingContainer) return;
    const _this = this;

    this.tieredPricingContainer
      .querySelectorAll('input[type="radio"]:checked')
      .forEach(function (radio) {
        _this.updateTieredPricing(radio.dataset.discount);
        _this.updateProductFormQuantity(radio.value);
      });

    this.tieredPricingContainer
      .querySelectorAll('input[type="radio"]')
      .forEach(function (radio) {
        radio.addEventListener("change", function (event) {
          _this.updateProductFormQuantity(this.value);
          _this.updateTieredPricing(this.dataset.discount);
        });
      });
  }

  updateTieredPricing(discount) {
    let priceWrapper = document.querySelector(
      "label.onetime-radio .radio__price"
    );
    let price = priceWrapper.querySelector("i").innerText;

    if (discount != 0) {
      priceWrapper.querySelector("i").classList.remove("hidden");

      priceWrapper.querySelector("b").innerText =
        `$${(parseFloat(price.replace("$", "")) - discount).toFixed(2)}`;

      this.priceAnimation();
    } else {
      priceWrapper.querySelector("b").innerText = price;
      priceWrapper.querySelector("i").classList.add("hidden");
    }

    document
      .querySelectorAll('input[name="selling_plan"]')
      .forEach(function (input) {
        input.value = ""; // clear the selling plan id
      }); // make sure that the selling plan value is cleared
  }

  priceAnimation() {
    let priceElem = document.querySelector(`.onetime-radio .radio__price`);
    if (priceElem) {
      priceElem.classList.add("highlight");

      let parentElem = priceElem.querySelector(".price-change");

      console.log("parentElem", parentElem);

      for (var i = 0; i < 360; i += 10) {
        const particle = document.createElement("div");
        particle.style = `--r:${i}deg`;
        parentElem.append(particle);
      }

      parentElem.classList.add("show");

      setTimeout(function () {
        parentElem.innerHTML = "";
      }, 1300);

      setTimeout(function () {
        priceElem.classList.remove("highlight");
      }, 2000);
    }
  }

  updateProductFormQuantity(qty) {
    this.productScope
      .querySelectorAll('form[action*="/cart/add"]')
      .forEach(function (productForm) {
        if (productForm.querySelector('input[name="quantity"]')) {
          productForm.querySelector('input[name="quantity"]').value = qty;
        } else {
          var qty_input = document.createElement("input");
          qty_input.name = "quantity";
          qty_input.value = qty;
          qty_input.type = "hidden";
          productForm.appendChild(qty_input);
        }
      });
  }

  connectedCallback() {
    this.onQuantityChange = () => this.updateDisplayedPrice();
    this.productScope.addEventListener('change', this.onQuantityChange);
    if (typeof subscribe === 'function' && typeof PUB_SUB_EVENTS !== 'undefined') {
      this.variantUnsubscribe = subscribe(PUB_SUB_EVENTS.variantChange, (event) => {
        if (String(event.data?.sectionId) === this.productScope.dataset.section) this.init();
      });
    }
  }

  disconnectedCallback() {
    this.productScope.removeEventListener('change', this.onQuantityChange);
    this.variantUnsubscribe?.();
  }

  init() {
    if (!this.form || !this.sellingPlanContainer) return;
    const variantId = this.form.querySelector('[name="id"]')?.value;
    this.sellingPlanContainer.querySelectorAll('.selling-plans').forEach((plans) => {
      plans.classList.toggle('selling-plan-hide', plans.dataset.variant !== variantId);
      const select = plans.querySelector('.selling-plan-select');
      if (select && !select.dataset.lfBound) {
        select.dataset.lfBound = 'true';
        select.addEventListener('change', () => this.updateSelectedPlan());
      }
    });
    this.updateSelectedPlan();
  }

  updateSelectedPlan() {
    const select = this.querySelector('.selling-plans:not(.selling-plan-hide) .selling-plan-select');
    if (!select || !this.form) return;
    const isSubscription = this.querySelector('[value="subscription"]').checked;
    let input = this.form.querySelector('[name="selling_plan"]');
    if (!input) {
      input = document.createElement('input');
      input.type = 'hidden';
      input.name = 'selling_plan';
      this.form.appendChild(input);
    }
    input.value = isSubscription ? select.value : '';
    this.updateDisplayedPrice();
  }

  updateDisplayedPrice() {
    const option = this.querySelector('.selling-plans:not(.selling-plan-hide) option:checked');
    if (!option) return;
    const quantity = Math.max(1, Number(this.form?.querySelector('[name="quantity"]')?.value || 1));
    const unitPrice = Number(option.dataset.unitPrice);
    const comparePrice = Number(option.dataset.comparePrice);
    if (!Number.isFinite(unitPrice)) return;
    const format = (cents) => new Intl.NumberFormat(document.documentElement.lang || 'en-US', {
      style: 'currency', currency: this.dataset.currency || 'USD'
    }).format(cents / 100);
    this.querySelector('[data-subscription-price]').textContent = format(unitPrice * quantity);
    const comparison = this.querySelector('.subscription-radio .small-text');
    if (comparison) comparison.textContent = format(comparePrice * quantity);
  }
}

if (!customElements.get("subscription-picker")) {
  customElements.define("subscription-picker", SubscriptionPicker);
}
